import { Component, OnDestroy, OnInit } from '@angular/core';
import { PaymentPaymentOptionCardFormAbstractForm } from '../payment.payment.option.card.form.abstract-form';
import { FormControl, Validators } from '@angular/forms';
declare var PagSeguro: any;

@Component({
    'selector': 'payment-payment-option-card-form-pagseguro',
    'templateUrl': './payment.payment.option.card.form.pagseguro.component.html'
})
export class PaymentPaymentOptionCardFormPagSeguroComponent extends
    PaymentPaymentOptionCardFormAbstractForm implements OnInit, OnDestroy {
    private payloadControl: FormControl;
    private payloadControlAdded = false;

    ngOnInit() {
        this.payloadControl = new FormControl('', [Validators.required]);
    }
    ngOnDestroy() {
        if (this.payloadControlAdded) {
            this.form.removeControl('payload');
            this.payloadControlAdded = false;
        }
    }
    public buildPayload() {
        if (this.form.valid) {
            this.payloadControl.setValue({});

            this.form.addControl('payload', this.payloadControl);
            this.payloadControlAdded = true;

            this.createToken();
        } else {
            this.pending.emit();
        }
    }

    private createToken() {
        var card = PagSeguro.encryptCard({
            publicKey: this.paymentGateway.publishable_key,
            holder: this.form.controls.holder_name.value,
            number: this.form.controls.number.value.replace(/\s/g, ''),
            expMonth: this.form.controls.expiration_month.value,
            expYear: this.form.controls.expiration_year.value,
            securityCode: this.form.controls.cvc.value
        });

        if (!card.hasErrors) {
            this.setToPayload('encrypted', card.encryptedCard);
            this.ready.emit();
            return;
        }

        console.warn(card.errors);
    }
    private setToPayload(key: string, value: any) {
        const payload = this.payloadControl.value || {};
        payload[key] = value;

        this.payloadControl.setValue(payload);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/payment/payment/option/card/option/form/pagseguro/payment.payment.option.card.form.pagseguro.component.ts